import {
  usePopoverDisclosure,
  PopoverDisclosureOptions,
  PopoverDisclosureHTMLProps,
} from 'reakit';
import { createComponent, createHook } from 'reakit-system';

import { useBox } from '../../Box/Box';
import { useField, FieldHTMLProps, FieldOptions } from '../../Field/Field';

type DisclosureFieldOptions = FieldOptions & PopoverDisclosureOptions;
type DisclosureFieldHTMLProps = Omit<FieldHTMLProps, 'type'> &
  Omit<PopoverDisclosureHTMLProps, 'type'>;

const useDisclosureField = createHook<
  DisclosureFieldOptions,
  DisclosureFieldHTMLProps
>({
  name: 'DisclosureField',
  keys: ['disabled'],
  compose: [useBox, usePopoverDisclosure, useField],
  useComposeProps({ disabled, ...options }, props) {
    let newProps = { ...props };

    newProps = usePopoverDisclosure(options, newProps, true);
    newProps = useField(options, newProps, true);

    return {
      ...newProps,
      'aria-disabled': disabled,
      onChange: disabled
        ? () => {
            /* ignore */
          }
        : newProps.onChange,
      onKeyDown: disabled
        ? (event) => {
            if (event.key !== 'Tab') {
              event.preventDefault();
            }
          }
        : newProps.onKeyDown,
      type: 'text',
    };
  },
});

export const DisclosureField = createComponent({
  as: 'input',
  useHook: useDisclosureField,
  memo: true,
});
